<template>
  <div class="card border-0 shadow-sm h-100">
    <div class="card-body p-4 d-flex flex-column">
      <h5 class="card-title d-flex align-items-center gap-2 mb-2">
        <vue-feather :type="icono" size="20" />
        {{ titulo }}
      </h5>
      <p class="text-muted mb-4">
        <slot />
      </p>

      <div v-if="cargando" class="text-muted py-3">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Cargando configuración...
      </div>

      <form v-else class="row g-3 align-items-end" @submit.prevent="guardar">
        <div class="col-sm-7">
          <label class="form-label fw-semibold" :for="`maxFilas-${tipo}`">Máximo de filas por archivo</label>
          <div class="input-group">
            <input
              :id="`maxFilas-${tipo}`"
              v-model.number="maxFilas"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': error }"
              :min="busquedaExcel.minimo"
              :max="busquedaExcel.maximo"
              step="1"
            />
            <span class="input-group-text">filas</span>
          </div>
        </div>
        <div class="col-sm-5">
          <button type="submit" class="btn btn-primary d-flex align-items-center gap-2" :disabled="guardando || !hayCambios">
            <span v-if="guardando" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <vue-feather v-else type="check" size="16" />
            Guardar
          </button>
        </div>
        <div class="col-12 mt-1">
          <div v-if="error" class="invalid-feedback d-block">{{ error }}</div>
          <div class="form-text">
            Rango permitido: {{ busquedaExcel.minimo }} a {{ busquedaExcel.maximo }}.
          </div>
        </div>
      </form>

      <p v-if="!cargando && ultimaActualizacion" class="small text-muted mt-auto pt-4 mb-0">
        <vue-feather type="clock" size="14" class="me-1" />
        Última actualización: {{ ultimaActualizacion }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "LimiteExcelCard",
  props: {
    tipo: { type: String, required: true, validator: (v) => ["banco", "gs1"].includes(v) },
    titulo: { type: String, required: true },
    icono: { type: String, default: "file-text" },
    cargando: { type: Boolean, default: false },
  },
  data() {
    return {
      maxFilas: null,
      error: "",
      guardando: false,
    };
  },
  computed: {
    ...mapState("configuracion", ["busquedaExcel"]),
    limite() {
      return this.busquedaExcel[this.tipo] || {};
    },
    hayCambios() {
      return Number(this.maxFilas) !== Number(this.limite.maxFilas);
    },
    totalConEncabezado() {
      const n = Number(this.maxFilas);
      return Number.isInteger(n) && n > 0 ? n + 1 : "—";
    },
    ultimaActualizacion() {
      const fecha = this.limite.fecha_Update;
      if (!fecha) return "";
      const d = new Date(fecha);
      return Number.isNaN(d.getTime()) ? "" : d.toLocaleString("es-MX");
    },
  },
  watch: {
    "limite.maxFilas": {
      handler(valor) {
        this.maxFilas = valor;
        this.error = "";
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("configuracion", ["guardarBusquedaExcel"]),
    validar() {
      const { minimo, maximo } = this.busquedaExcel;
      const n = Number(this.maxFilas);
      if (!Number.isInteger(n) || n < minimo || n > maximo) {
        return `Ingresa un número entero entre ${minimo} y ${maximo}`;
      }
      return "";
    },
    async guardar() {
      this.error = this.validar();
      if (this.error) return;
      this.guardando = true;
      try {
        await this.guardarBusquedaExcel({ tipo: this.tipo, maxFilas: Number(this.maxFilas) });
        Swal.fire({
          icon: "success",
          title: "Configuración guardada",
          text: `${this.titulo} acepta ahora hasta ${this.limite.maxFilas} filas (sin contar el encabezado).`,
        });
      } catch (e) {
        Swal.fire({ icon: "error", title: e.code || "Error", text: e.msg || "No se pudo guardar la configuración." });
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>
